import styled, { keyframes } from 'styled-components';

import { beam } from '@styles/colors/themes';

import { ControlledMenu, MenuButton, MenuItem } from '@szhsin/react-menu';
import {
  menuSelector,
  menuDividerSelector,
} from '@szhsin/react-menu/style-utils';

export const Wrapper = styled.div``;

const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const Menu = styled(ControlledMenu)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
    border-radius: 8px;
    padding: 12px 16px 24px 16px;
    width: 261px;
    transition: unset;
  }

  ${menuSelector.stateOpen} {
    animation: ${menuShow} 0.2s linear;
  }

  // NOTE: animation-fill-mode: forwards is required to
  // prevent flickering with React 18 createRoot()
  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }

  ${menuDividerSelector.name} {
    margin: 0.5rem 0.625rem;
  }
`;

export const IconButton = styled(MenuButton)`
  border: 0;
  background-color: transparent;
  border-radius: 8px;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  width: 42px;
  outline: 0;

  & span {
    display: inline-flex;
  }

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 16px;
  font-weight: 600;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 16px;
`;

export const Close = styled(MenuItem)`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;
  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const MenuListItem = styled.div``;

export const Item = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: ${beam.font.primary};
  gap: 4px;

  transition: 0.2s;
  :hover {
    background-color: #f6f8ff;
  }
`;

interface IItemText {
  disabled?: boolean;
  description?: string;
}

export const ItemText = styled.div<IItemText>`
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#474d66')};
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  padding: 5px 12px;
  width: 100%;
  margin-top: 8px;

  span {
    display: inline-flex;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
`;

export const SearchButton = styled.div`
  font-size: 12px;
  color: #1371fe;
  cursor: pointer;
`;

export const SearchClear = styled.div`
  cursor: pointer;
`;

export const InitialSearchedItems = styled.ul`
  margin-top: 8px;
  padding: 0;
  list-style: none;
`;

export const InitialSearchedItem = styled.li`
  min-height: 42px;
  font-size: 14px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: ${beam.font.primary};
  gap: 4px;

  transition: 0.2s;
  :hover {
    background-color: #f6f8ff;
  }

  :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const CurrentFilter = styled.div`
  margin-top: 20px;
`;

export const CurrentFilterTitle = styled.h4`
  font-size: 12px;
`;

export const CurrentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  padding: 8px;

  span {
    display: inline-flex;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    color: ${beam.font.primary};
    gap: 4px;

    transition: 0.2s;
    :hover {
      background-color: #f6f8ff;
    }
  }
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background: #e6e8f0;
  margin: 8px 0;
`;
